import { ORGANIZATIONS_API, ORGANIZATIONS_NDI_API, SUBCATEGORY_NDI_API } from "../../../Utilities/APIs";
import PcSSCRUD from "../../Partials/Layouts/CRUDs/CRUDLayouts/SSCRUD/PcSSCRUD";

function OrganizationNDICards() {
  return (
    <PcSSCRUD
        // parentChild props
        parentDBField={'organization'}
        
        // common props
        api={ORGANIZATIONS_NDI_API}
        screenTopicSingular={'Organization NDI Card'}
        screenTopicPlural={'Organization NDI Cards'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete
        
        // select props
        selectApi={ORGANIZATIONS_API}
        selectType={'parent-child'}
        selectDBField={'organization'}
        selectName={'Organization'}

        // second select props
        secondSelectApi={SUBCATEGORY_NDI_API}
        secondSelectType={'parent-child'}
        secondSelectDBField={'subcatNDICard'}
        secondSelectName={'Subcategory NDI'}
    />
  )
}

export default OrganizationNDICards